// `kind` the backend declares on the celery tasks that generate document manager items
// (previews, the full document) or convert them to PDF. Their progress is shown in the
// document manager footer.
export const DOCUMENT_TASK_KIND = 'document'

export const isDocumentTask = (task: RunningTask) => task.kind === DOCUMENT_TASK_KIND
